import { Component, OnInit } from '@angular/core';
import { Category } from '../../../models/category';
import { Appli } from '../../../models/appli';
import { SubCategory } from '../../../models/sub-category';
import { AdminAppliService } from '../appli.service';
import { AdminCategoryService } from '../../catetory/category.service';
import { AdminSubCategoryService } from '../../sub-category/sub-category.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'ozm-appli-detail',
  templateUrl: './appli-detail.component.html',
  styleUrls: ['./appli-detail.component.scss']
})
export class AdminAppliDetailComponent implements OnInit {
  appli: Appli;
  categories: Category[];
  subCategories: SubCategory[];
  subCatsFiltered: SubCategory[];
  selectedId: string;

  constructor(
    private _adminAppliService: AdminAppliService,
    private _categoryService: AdminCategoryService,
    private _subCategoryService: AdminSubCategoryService,
    private _router: Router,
    private _route: ActivatedRoute
  ){}

  ngOnInit(): void {
      this.getAppli();
  }

  appliSubmit() {
    if(this.appli._id) {
      this._adminAppliService.updateAppli(this.appli).subscribe(() => {
        this._router.navigate(['/appli-list'])
      });
    } else {
      this._adminAppliService.addAppli(this.appli).subscribe(() => {
        this._router.navigate(['/appli-list'])
      });
    }
  }

  deleteAppli() {
    this._adminAppliService.deleteAppli({_id:this.appli._id}).subscribe(() => {
      this._router.navigate(['/appli-list'])
    });
  }

  onCategoryChange() {

  }

  onSubCategoryChange() {

  }
   
  getAppli() {
    const id = this._route.snapshot.paramMap.get('id');
    console.log('In appli-detail-component ts id');
    console.log(id);

    if(id) {
      this._adminAppliService.getApplis1({_id: id})
        .subscribe( (applis: Appli[]) => {
          console.log(applis, 'DDDDDDDDDDDDDDDDDD');
          this.appli = applis[0]
        });
    }
    else {
      this.appli = this.getModel();
    }
  }

  getModel() {
    return Object.assign({}, {
      name: '',
      icon: '',
      category: '',
      subCategory: '',
      link: '',
      fallbackUrl: '',
      fallbackUrl2: '',
      order: 0,
      active: false,
      default: false,
      openByPackageName: false,
      androidImageUrl: ''
    }) as Appli;
  }

}
